import React from 'react';
import DisturboPageTemplate from '../../components/template-disturbo';
import { getProp, getPropAsset, getPropMarked } from '../utils';

const DisturboPreview = (props) => {
  const title = getProp(props, 'title');
  const text = getPropMarked(props, 'text');
  const image = getPropAsset(props, 'image');

  return <DisturboPageTemplate {...{ title, text, image }} />;
};

export default DisturboPreview;
